import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import config from 'app-customs/config/config';

import { CATEGORIES_DATA_TYPE, CATEGORIES_MAPPING } from 'app-customs/config/dataConfig';

import { SEARCH_MIN_CHARS } from 'app-customs/config/searchConfig';

import GenericIcon from 'src/components/generic-icon/GenericIcon';

import {
  FAVORITES_PAGE_KEY,
  LIST_PAGE_KEY,
  LIST_GROUPS_PAGE_KEY,
  SEARCH_PAGE_KEY,
  SYNOPTIC_AGENDA_PAGE_KEY,
  MEDIAS_FEED_PAGE_KEY,
  MEDIAS_PAGE_KEY,
} from 'src/pages/pagesKeys';

import SearchField from 'src/components/search/SearchField';

import './AppToolbar.scss';

export const APP_TOOLBAR_HEIGHT = 48;

const getButton = (icon, iconStyle, action, label, src, props) => {
  return (
    <span className="app-toolbar-icon" onClick={action} title={label}>
      <GenericIcon src={src} className={icon} {...props} style={iconStyle} />
    </span>
  );
};

class AppToolbar extends PureComponent {
  setSearchFieldRef = (ref) => {
    this.searchField = ref;
  };

  hasRootCategoryButtonInToolbar = () =>
    !this.props.searchFieldVisible && this.props.rootCategoryButtonInToolbar;

  hasSynchroFavBtnStatus = () =>
    this.props.isSynchroFavFeatureEnabled &&
    !this.props.searchFieldVisible &&
    this.props.synchroFavBtnStatus;

  // BACK

  hasBackButton = () => this.props.hasBackButton;

  buttonProps = (button) => this.props.listConfigToolBarButton?.[button];

  handleClickOnBackButton = () => {
    if (this.props.searchFieldVisible) {
      this.clearSearchResults();
      this.hideSearchField();
    } else {
      this.props.actions.navigateBack();
    }
  };

  // HOME

  hasHomeButton = () => !this.props.searchFieldVisible && this.props.hasHomeButton;

  navigateToHome = () => {
    let homePage = config.getHomePage(this.props.profile);
    this.props.actions.navigate(homePage.pageKey, homePage.props);
  };

  // FAVORITES

  hasFavButton = () => !this.props.searchFieldVisible && this.props.hasFavButton === true;

  navigateToFavoritesPage = () => {
    this.props.actions.navigate(FAVORITES_PAGE_KEY);
  };

  // SYNOPTIC

  hasSynopticAgendaButton = () =>
    !this.props.searchFieldVisible && this.props.hasSynopticAgendaButton;

  navigateToSynopticAgendaPage = () => {
    this.props.actions.navigateToSynopticWithoutContext(this.props.profile);
  };

  // AGENDA

  hasBackToAgendaButton = () => !this.props.searchFieldVisible && this.props.hasBackToAgendaButton;

  navigateBackToAgendaPage = () => {
    this.props.actions.navigate(LIST_GROUPS_PAGE_KEY, this.props.agendaProps);
  };

  // MENU

  hasMenuButton = () => this.props.hasMenuButton;

  openMenu = () => {
    // this.hideSearchField();
    this.props.actions.openMenu(this.props.pageKey);
  };

  // FILTER

  hasFilterButton = () => !this.props.searchFieldVisible && this.props.hasFilterButton;

  handleFilterButtonClick = () => {
    this.props.actions.showFilterDialog(this.props.contextualDataTypes);
  };

  navigateToSocialPage = () => {
    this.props.actions.navigate(
      this.props.pageKey !== MEDIAS_FEED_PAGE_KEY ? MEDIAS_FEED_PAGE_KEY : MEDIAS_PAGE_KEY
    );
  };

  // social

  hasSocialButtonInToolbar = () => this.props.hasSocialButtonInToolbar;

  // SEARCH
  hasSearchButton = () =>
    this.props.pageKey !== SEARCH_PAGE_KEY &&
    !this.props.searchFieldVisible &&
    this.props.hasSearchButton === true;

  handleSearchButtonClick = () => {
    if (this.props.contextualDataTypes) {
      this.showSearchField();
      this.focusOnSearchField();
    } else {
      this.props.actions.navigate(SEARCH_PAGE_KEY);
    }
  };

  showSearchField = () => {
    this.props.actions.setSearchFieldVisible(this.props.pageKey, true);
  };

  focusOnSearchField = () => {
    // NB: on iOS, the focus can only be set following a user action (no timeout possible)
    if (this.searchField) {
      this.searchField.focus();
    }
  };

  getSearchFieldPlaceholder({ contextualDataTypes, labels }) {
    const placeholder = [];
    if (Array.isArray(contextualDataTypes)) {
      contextualDataTypes.forEach((dataType) => {
        let type = dataType;

        if (CATEGORIES_DATA_TYPE.indexOf(dataType) > -1) {
          type = CATEGORIES_MAPPING[dataType];
        }

        const text = labels.data[type]?.plural?.toLowerCase();

        if (placeholder.indexOf(text) === -1) {
          placeholder.push(text);
        }
      });
    }

    if (labels.search.keywords) {
      placeholder.push(labels.search.keywords);
    }

    return placeholder.join(', ');
  }

  hideSearchField = () => {
    this.props.actions.setSearchFieldVisible(this.props.pageKey, false);
  };

  clearSearchResults = () => {
    this.props.actions.clearSearchResults(this.props.pageKey);
  };

  performSearch = (str) => {
    this.props.actions.performSearch(str, this.props.pageKey, this.props.contextualDataTypes, true);
  };

  getClassName = () =>
    'app-toolbar' +
    (this.props.theme ? ' theme-' + this.props.theme : '') +
    (!this.props.disableDropShadow ? ' at-with-dropshadow' : '');

  render() {
    if (this.props.isDisplayed)
      return (
        <div className={this.getClassName()} ref={this.setToolbarEl}>
          <div className="left">
            {this.hasBackButton() &&
              getButton(
                this.buttonProps('BackButton')?.className || '',
                this.buttonProps('BackButton')?.style || { width: '1.7em', height: '1.7em' },
                this.buttonProps('BackButton')?.action || this.handleClickOnBackButton,
                this.buttonProps('BackButton')?.label || this.props.labels.common.goBack,
                this.buttonProps('BackButton')?.src || 'icons-svg/appToolBar/fleche.svg',
                this.buttonProps('BackButton')?.props || { st0Class: 'app-toolbar-icon-st0' }
              )}
          </div>

          <CSSTransition in={this.props.searchFieldVisible} classNames="search-field" timeout={0}>
            <SearchField
              key={0}
              ref={this.setSearchFieldRef}
              placeholder={this.getSearchFieldPlaceholder(this.props)}
              perform={this.performSearch}
              clearResults={this.clearSearchResults}
              searchResults={this.props.searchResults}
              minChars={this.props.pageKey === LIST_PAGE_KEY ? 1 : SEARCH_MIN_CHARS}
              isContextual={true}
              hasCancelButton={true}
              onCancel={this.hideSearchField}
            />
          </CSSTransition>

          {!this.props.searchFieldVisible && (
            <div className="center content-font">
              {this.props.contextualTitle || this.props.title}
            </div>
          )}

          <div className="right">
            {this.props.listToolBarButton &&
              this.props.listToolBarButton.length !== 0 &&
              this.props.listToolBarButton.map((button) =>
                getButton(
                  button.className + ' ' + button?.isFontAwesome || '',
                  button.style,
                  button.action,
                  button.label,
                  button.src,
                  button.props
                )
              )}
            {this.hasSynopticAgendaButton() &&
              getButton(
                this.buttonProps('SynopticAgendaButton')?.className || '',
                this.buttonProps('SynopticAgendaButton')?.style || { width: '1.7em', height: '1.7em' },
                this.buttonProps('SynopticAgendaButton')?.action || this.navigateToSynopticAgendaPage,
                this.buttonProps('SynopticAgendaButton')?.label ||
                  this.props.labels.common.goToSynopticAgenda,
                this.buttonProps('SynopticAgendaButton')?.src ||
                  'icons-svg/appToolBar/calendar-alt-regular.svg',
                this.buttonProps('SynopticAgendaButton')?.props || { st0Class: 'app-toolbar-icon-st0' }
              )}

            {this.hasBackToAgendaButton() &&
              getButton(
                this.buttonProps('BackToAgendaButton')?.className || 'calendar-week-icon',
                this.buttonProps('BackToAgendaButton')?.style || null,
                this.buttonProps('BackToAgendaButton')?.action || this.navigateBackToAgendaPage,
                this.buttonProps('BackToAgendaButton')?.label || this.props.labels.common.goBackToAgenda,
                this.buttonProps('BackToAgendaButton')?.src ||
                  'icons-svg/appToolBar/calendar-week-solid.svg',
                this.buttonProps('BackToAgendaButton')?.props
              )}

            {this.hasRootCategoryButtonInToolbar() &&
              getButton(
                this.buttonProps('RootCategoryButtonInToolbar')?.className || 'list-icon',
                this.buttonProps('RootCategoryButtonInToolbar')?.style || { fontSize: '22px' },
                this.buttonProps('RootCategoryButtonInToolbar')?.action ||
                  this.props.navigateToRootCategory,
                this.buttonProps('RootCategoryButtonInToolbar')?.label ||
                  this.props.labels.common.goToRootCategory,
                this.buttonProps('RootCategoryButtonInToolbar')?.src ||
                  'icons-svg/appToolBar/list-solid.svg',
                this.buttonProps('RootCategoryButtonInToolbar')?.props
              )}

            {this.hasHomeButton() &&
              getButton(
                this.buttonProps('HomeButton')?.className || '',
                this.buttonProps('HomeButton')?.style || { width: '1.7em', height: '1.7em' },
                this.buttonProps('HomeButton')?.action || this.navigateToHome,
                this.buttonProps('HomeButton')?.label || this.props.labels.common.goToHome,
                this.buttonProps('HomeButton')?.src || 'icons-svg/Home.svg',
                this.buttonProps('HomeButton')?.props || { st0Class: 'app-toolbar-icon-st0' }
              )}

            {this.hasFavButton() === true &&
              getButton(
                this.buttonProps('FavButton')?.className || '',
                this.buttonProps('FavButton')?.style || { width: '1.7em', height: '1.7em' },
                this.buttonProps('FavButton')?.action || this.navigateToFavoritesPage,
                this.buttonProps('FavButton')?.label || this.props.labels.common.goToFavorites,
                this.buttonProps('FavButton')?.src || 'icons-svg/Fav.svg',
                this.buttonProps('FavButton')?.props || { st0Class: 'app-toolbar-icon-st0' }
              )}

            {this.hasSearchButton() === true &&
              getButton(
                this.buttonProps('SearchButton')?.className || '',
                this.buttonProps('SearchButton')?.style || { width: '1.7em', height: '1.7em' },
                this.buttonProps('SearchButton')?.action || this.handleSearchButtonClick,
                this.buttonProps('SearchButton')?.label || this.props.labels.common.goToSearch,
                this.buttonProps('SearchButton')?.src || 'icons-svg/Search.svg',
                this.buttonProps('SearchButton')?.props || { st0Class: 'app-toolbar-icon-st0' }
              )}

            {this.hasFilterButton() &&
              getButton(
                this.buttonProps('FilterButton')?.className +
                  (this.props.isDataFiltered
                    ? this.buttonProps('FilterButton')?.classNameActivated
                    : '') || 'filter-icon' + (this.props.isDataFiltered ? ' filter-enabled' : ''),
                this.buttonProps('FilterButton')?.style || { width: '0.8em', height: '0.8em' },
                this.buttonProps('FilterButton')?.action || this.handleFilterButtonClick,
                this.buttonProps('FilterButton')?.label || this.props.labels.common.goToFilter,
                this.buttonProps('FilterButton')?.src || 'icons-svg/appToolBar/filter-solid.svg',
                this.buttonProps('FilterButton')?.props
              )}

            {this.props.hasSocialButtonInToolbar === true &&
              getButton(
                this.buttonProps('SocialButtonInToolbar')?.className || 'social-icon',
                this.buttonProps('SocialButtonInToolbar')?.style || { width: '0.8em', height: '0.8em' },
                this.buttonProps('SocialButtonInToolbar')?.action || this.navigateToSocialPage,
                this.buttonProps('SocialButtonInToolbar')?.label || this.props.labels.menu.medias,
                this.buttonProps('SocialButtonInToolbar')?.src || 'icons-svg/social/th-solid.svg',
                this.buttonProps('SocialButtonInToolbar')?.props
              )}

            {this.hasSynchroFavBtnStatus() &&
              getButton(
                `${this.buttonProps('SynchroFavBtnStatus')?.className}${
                  this.props.synchroFavBtnStatus
                }` || `synchro-fav-btn synchro-fav-btn-${this.props.synchroFavBtnStatus}`,
                this.buttonProps('SynchroFavBtnStatus')?.style || { width: '1.7em', height: '1.7em' },
                this.buttonProps('SynchroFavBtnStatus')?.action ||
                  this.props.actions.synchroFavoritesIconClicked,
                this.buttonProps('SynchroFavBtnStatus')?.label || '',
                this.buttonProps('SynchroFavBtnStatus')?.src || 'icons-svg/klipso/sync-solid.svg',
                this.buttonProps('SynchroFavBtnStatus')?.props || { st0Class: 'app-toolbar-icon-st0' }
              )}

            {this.hasMenuButton() === true &&
              getButton(
                this.buttonProps('MenuButton')?.className || '',
                this.buttonProps('MenuButton')?.style || { width: '1.7em', height: '1.7em' },
                this.buttonProps('MenuButton')?.action || this.openMenu,
                this.buttonProps('MenuButton')?.label || this.props.labels.common.openMenu,
                this.buttonProps('MenuButton')?.src || 'icons-svg/appToolBar/Burger.svg',
                this.buttonProps('MenuButton')?.props || { st0Class: 'app-toolbar-icon-st0' }
              )}
          </div>
        </div>
      );
    return null;
  }
}

AppToolbar.propTypes = {
  labels: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  profile: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool,
  title: PropTypes.string.isRequired,
  contextualTitle: PropTypes.string,
  pageKey: PropTypes.string,
  listConfigToolBarButton: PropTypes.object,
  listToolBarButton: PropTypes.bool,
  hasBackButton: PropTypes.bool,
  hasMenuButton: PropTypes.bool,
  hasHomeButton: PropTypes.bool,
  hasFavButton: PropTypes.bool,
  hasSearchButton: PropTypes.bool,
  hasSocialButtonInToolbar: PropTypes.bool,
  hasFilterButton: PropTypes.bool,
  hasSynopticAgendaButton: PropTypes.bool,
  agendaProps: PropTypes.object,
  hasBackToAgendaButton: PropTypes.bool,
  onSearchClear: PropTypes.func,
  synchroFavBtnStatus: PropTypes.string,
  rootCategoryButtonInToolbar: PropTypes.bool,
  navigateToRootCategory: PropTypes.func,
  searchResults: PropTypes.object,
  lastResize: PropTypes.number,
  isDataFiltered: PropTypes.bool,
  disableDropShadow: PropTypes.bool,
  searchFieldVisible: PropTypes.bool,
  theme: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => state['appToolbar'];

export default connect(mapStateToProps)(AppToolbar);
